import { resolveConfirm } from './resolveConfirm';
import { fillForms } from './fillForms';
import { generateFormsContent } from '../generateInformation/generateFormsContent';
import { resolveFinalMessage } from './resolveFinalMessage';
import { TTrConfirmProps } from '../../../components/OverrideFieldRow';
import ApiaField from '../../../../../../../../JSApi/ApiaField';
import { TMessageType } from '@apia/ai';
import closeTab from '../../../../../../../common/actions/closeTab';
import confirm from '../../../../../../../common/actions/execution/task/confirm';
import next from '../../../../../../../common/actions/execution/task/next';

export type TFieldValue = Record<string, string>[] | string;

export const resolveResponseResult = async (
  data: NonNullable<
    NonNullable<Awaited<ReturnType<typeof generateFormsContent>>>['data']
  >,
  // isForAutoComplete: boolean,
  isPhone: boolean,
) => {
  const form = JSON.parse(data.json) as {
    message: string;
    type: TMessageType;
    filledFormsMap: Record<string, TFieldValue>;
    mustClose: boolean;
    mustComplete: boolean;
  };
  if (form.mustClose) {
    closeTab();
  } else if (form.mustComplete) {
    const isComplete = window.STEP_QTY - (window.CURRENT_STEP ?? 1) == 0;
    if (isComplete) {
      confirm();
    } else {
      next();
    }
  } else {
    const filledFormsMap = form?.filledFormsMap;
    const formsMap: Record<string, Record<string, TFieldValue>> = {};
    const windowForms = window.ApiaFunctions.getAllForms();
    windowForms.map((f) => {
      f.getAllFields().map((fi) => {
        const mapKeys = Object.keys(filledFormsMap);

        const att =
          (fi as ApiaField)?.props?.field?.attName ||
          (fi as ApiaField)?.props?.name ||
          (fi as ApiaField)?.props?.title ||
          mapKeys.find((k) => fi.fldId?.endsWith(k));
        if (att) {
          const value = filledFormsMap[att];
          if (value) {
            if (!formsMap[f.getFormName()!]) {
              formsMap[f.getFormName()!] = {};
            }
            formsMap[f.getFormName()!][att] = value;
          }
        }
      });
    });

    let fillProps: {
      confirmProps: TTrConfirmProps[];
      confirmedValues: string[];
    } = { confirmedValues: [], confirmProps: [] };
    let needFinalMessage = true;
    // if (true) {
    fillProps = await fillForms(formsMap);
    if (fillProps.confirmProps.length !== 0) {
      resolveConfirm(fillProps, { ...form, filledFormsMap: formsMap }, isPhone);
      needFinalMessage = false;
    }
    // }
    //  else {
    //   fillProps = resolvePrompt(formsMap, fillProps);
    // }
    if (needFinalMessage)
      resolveFinalMessage(
        { ...form, filledFormsMap: formsMap },
        fillProps.confirmedValues,
      );
  }
};
